import React from 'react';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import RecipeCard from './RecipeCard';

const RecipeList = ({ title, category, recipes, onRecipeClick }) => (
  <div style={{ marginBottom: '20px', backgroundColor: 'white', padding: '15px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
    <h3 style={{ borderBottom: '2px solid #f39c12', paddingBottom: '8px', marginTop: 0, color: '#d35400' }}>{title}</h3>
    <Droppable droppableId={`recipes-${category}`}>
      {(provided, snapshot) => (
        <div 
          {...provided.droppableProps} 
          ref={provided.innerRef}
          style={{
            backgroundColor: snapshot.isDraggingOver ? '#fef9e7' : 'transparent',
            minHeight: '100px',
            padding: '10px 0',
            transition: 'background-color 0.2s',
            borderRadius: '4px'
          }}
        >
          {recipes && recipes.length > 0 ? (
            recipes.map((recipe, index) => (
              <Draggable 
                key={String(recipe.id)} 
                draggableId={String(recipe.id)} 
                index={index}
              >
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                      ...provided.draggableProps.style,
                      opacity: snapshot.isDragging ? 0.8 : 1,
                      marginBottom: '10px',
                    }}
                    onClick={() => onRecipeClick(recipe)}
                  >
                    <RecipeCard recipe={recipe} />
                  </div>
                )}
              </Draggable>
            ))
          ) : (
            <div style={{ padding: '20px', color: '#95a5a6', fontSize: '14px', textAlign: 'center', fontStyle: 'italic' }}>Drop recipes here</div>
          )}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  </div>
);

function RecipeSidebar({ recipes = [], onRecipeClick }) {
  const breakfastRecipes = recipes.filter(r => r.category === 'breakfast');
  const lunchRecipes = recipes.filter(r => r.category === 'lunch');
  const dinnerRecipes = recipes.filter(r => r.category === 'dinner');
  const snacksRecipes = recipes.filter(r => r.category === 'snacks');

  return (
    <div className="sidebar" style={{ width: '260px', overflowY: 'auto', padding: '15px', backgroundColor: '#fdf2e9', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
      <h2 style={{ color: '#e67e22', borderBottom: '2px solid #e67e22', paddingBottom: '10px', marginTop: 0 }}>Recipe Suggestions</h2>
      <RecipeList title="Breakfast" category="breakfast" recipes={breakfastRecipes} onRecipeClick={onRecipeClick} />
      <RecipeList title="Lunch" category="lunch" recipes={lunchRecipes} onRecipeClick={onRecipeClick} />
      <RecipeList title="Dinner" category="dinner" recipes={dinnerRecipes} onRecipeClick={onRecipeClick} />
      <RecipeList title="Snacks" category="snacks" recipes={snacksRecipes} onRecipeClick={onRecipeClick} />
    </div>
  );
}

export default RecipeSidebar;
